/**
 * 新建公告路由
 */
"use strict";
angular.module("newNoticeRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("newnotice", {
        url: "/newnotice?docId&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body">' +
                    '<div class="" ui-view="main"></div>' +
                    '</div>'
            },
            "header@newnotice": {
                templateUrl: 'header/backstageHeader_tpl.html',
                controller: 'backstageHeaderCtrl'
            },
            "main@newnotice": {
                templateUrl: "./main/backstage/noticeManagement/newNotice/newNotice_tpl.html",
                controller: "newNoticeCtrl"
            }
        }
    });
}]);